import { createStore } from "vuex";

// 创建一个新的 store 实例
export const store = createStore({
  state() {
    return {
      curMenu: "home",
      meshApp: undefined,
      sandpackApp: null,
    };
  },
  mutations: {
    setCurMenu(state: any, value: string) {
      state.curMenu = value;
    },
    setMeshApp(state: any, value: any) {
      state.meshApp = value;
    },
    setSandpackApp(state: any, value: any) {
      state.sandpackApp = value;
    },
  },
  actions: {
    increment({ state, commit }) {
      commit("setCurMenu");
    },
  },
  modules: {},
});
